<div class="scene" [ngClass]="{'scene-flex': !showEllipsis}" [class]="item.class">
  @if (item?.type_array == 2) {
    <div>
      @if (zoom != 4) {
        <div class="banner">
          <p>{{ item.description }}</p>
        </div>
      }
    </div>
  } @else {
    <div class="line">
      @if ((_gS.isMobile$ | async) && showMobileMenu) {
        <div class="menu-lat" (click)="$event.stopPropagation(); onContextMenu($event)">
          <span style="font-size: 17px !important;" class="material-icons">more_vert</span>
        </div>
      }
      <div class="row">
        <div class="td full w-100">
          @if (zoom < 3) {
            <p
              class="title">
              {{item.chapter_number}}/{{item.scene_number}}
              <span> {{item.scene_header_eng}}</span>
            </p>
          }
          @if (zoom >= 3) {
            <p
              class="title"
              [ngClass]="{'ellipsis':showEllipsis}"
              [tooltip]="tooltipText"
              [placement]="'top'">
              {{item.chapter_number}}/{{item.scene_number}}
              <span> {{item.set_name}}. {{item.location_name}}</span>
            </p>
          }
        </div>
      </div>
      @if (zoom < 3) {
        <div class="td full w-100">
          <p class="small characters">{{item.charactersList ? item.charactersList : ''}}</p>
          <p class="small description">{{item.description}}</p>
        </div>
      }
    </div>
    @if (zoom < 2) {
      <div
        class="mark-strip relative"
        [class]="item.class_scn_status"
        (mouseenter)="toggleSelected(true)"
        (mouseleave)="toggleSelected(false)">
        @if (item.scene_status_id > SCENE_STATUS.NotAssigned && item.scene_status_id != SCENE_STATUS.Cancel) {
          {{item.last_unit_name}}&nbsp;&nbsp;{{item.scene_status_id}}
        }
        {{item.last_shooting_date | date: 'MMM dd'}}
        <!-- <div *ngIf="isSelected" class="hover-mark-strip contextmenu white">
        <p>{{item.last_unit_name}}&nbsp;&nbsp;{{item.last_shooting_date | date: 'MMM dd yyyy'}}</p>
      </div> -->
    </div>
  }
}
</div>